import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Form, reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validations, validateCase as vCase } from 'core/validate'
import { ChangePRCreatorAndRequesterContainer } from './styled'
import { Field, FieldArray } from 'redux-form'
import { Button, Icon } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { changePrRequester } from 'ducks/support'

// import r from 'reactotron-react-js'

const ChangePRCreatorAndRequester = (props) => {
  const { members, memberLoading, reset } = props

  useEffect(() => {
    if (!members.length) {
      // props.getHrmsMembers()
      props.getAllMembers()
    }
  }, [])

  const memberOptions = members.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  const lengthTen = value => value && value.length !== 10 ? 'PR Number must be 10 characters' : undefined

  const renderDocNumbers = ({ fields, meta: { error, submitFailed } }) => {
    return (
      <React.Fragment>
        <div className='rowFields' style={{ flexWrap: 'wrap' }}>
          {fields.map((docs, index) => (
            <div key={index} style={{ flex: '1 0 21%', maxWidth: '25%' }} >
              <Field 
                name={`${docs}.docNumber`} 
                label={`Document #${index + 1}`} 
                type={type.text}
                action={{
                  color: 'red',
                  icon: 'trash',
                  type: 'button',
                  onClick: () => fields.remove(index)
                }}
                specialOnChange={(value) => {
                  if (value.length === 10) {
                    // r.log({value})
                    // lengthTen(value)
                  }
                }}
                // validate={[lengthTen]}
                component={FieldInput} />
            </div>
          ))}
        </div>
        <div>
          <Button 
            icon 
            color='green' 
            labelPosition='left' 
            type='button' 
            onClick={() => fields.push({})}
            style={{ marginBottom: '10px' }}
          >
            <Icon name='plus' />
            Add Document Number
          </Button>
          {submitFailed && error && <span>{error}</span>}
        </div>
      </React.Fragment>
    )
  }

  return (
    <ChangePRCreatorAndRequesterContainer>
      <Form>
        <FieldArray name='docNumbers' component={renderDocNumbers} />
        <div className='rowFields'>
          <Field 
            name='newRequester' 
            label='New Requester' 
            loading={memberLoading}
            options={memberOptions} 
            type={type.select}
            component={FieldInput} />
          <Field 
            name='oldRequester' 
            label='Old Requester' 
            ignoreClearValue={false}
            loading={memberLoading}
            options={memberOptions} 
            type={type.select}
            component={FieldInput} />
        </div>
        <div className='rowFields'>
          <Field 
            name='newCreator' 
            label='New Creator' 
            loading={memberLoading}
            options={memberOptions} 
            type={type.select}
            component={FieldInput} />
          <Field 
            name='oldCreator' 
            label='Old Creator'
            ignoreClearValue={false}
            loading={memberLoading}
            options={memberOptions} 
            type={type.select}
            component={FieldInput} />
        </div>
        <div className='btnContainer'>
          <Button
            type='button'
            content='Submit'
            color='blue'
            icon='paper plane outline'
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={() => props.changePrRequester(props.valueForm, reset)}
          />
        </div>
      </Form>
    </ChangePRCreatorAndRequesterContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    members: state.member.members,
    memberLoading: state.member.memberLoading,
    valueForm: getFormValues('changePrRequesterForm')(state) || {},
    initialValues: {
      docNumbers: [
        { docNumber: '' }
      ]
    }
  })
}

const mapDispatchToProps = {
  getHrmsMembers,
  changePrRequester,
  getAllMembers
}

const validate = (values) => {
  let errors = {}
  validations(values, 'documentNumber', [vCase.require], errors)
  validations(values, 'newRequester', [vCase.require], errors)
  validations(values, 'newCreator', [vCase.require], errors)

  return errors
}

const ChangePRCreatorAndRequesterFormForm = reduxForm({
  form: 'changePrRequesterForm',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(ChangePRCreatorAndRequester)

export default connect(mapStateToProps, mapDispatchToProps)(ChangePRCreatorAndRequesterFormForm)